var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTaskLinkedinIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.5 2C20.8798 2 22 3.1202 22 4.5V19.5C22 20.8798 20.8798 22 19.5 22H4.5C3.1202 22 2 20.8798 2 19.5V4.5C2 3.1202 3.1202 2 4.5 2H19.5ZM4.1875 5.86143C4.1875 4.87382 4.93637 4.1203 6.0825 4.1203C7.22797 4.1203 7.93328 4.87382 7.95496 5.86143C7.95496 6.82831 7.22789 7.60261 6.0598 7.60261H6.03816C4.91359 7.60261 4.1875 6.82831 4.1875 5.86143ZM4.38477 8.97913H7.73477V19.0558H4.38477V8.97913ZM15.9564 8.74219C14.1794 8.74219 13.3835 9.71941 12.9378 10.4058V8.97914H9.58862C9.63304 9.92434 9.58862 19.0557 9.58862 19.0557H12.9377V13.4282C12.9377 13.127 12.9594 12.8259 13.0482 12.6106C13.2899 12.0091 13.8413 11.3859 14.7666 11.3859C15.978 11.3859 16.4633 12.3103 16.4633 13.6643V19.0557H19.8126V13.2772C19.8126 10.182 18.1601 8.74219 15.9564 8.74219Z",
    fill: "#1282B2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTaskLinkedinIcon);
export default __webpack_public_path__ + "static/media/TaskLinkedinIcon.454aab3ace357c2073527735b777e47b.svg";
export { ForwardRef as ReactComponent };